import { render, staticRenderFns } from "./m-block-welcome-premium.vue?vue&type=template&id=0d65b7a0&scoped=true&lang=pug"
import script from "./m-block-welcome-premium.vue?vue&type=script&lang=js"
export * from "./m-block-welcome-premium.vue?vue&type=script&lang=js"
import style0 from "./m-block-welcome-premium.vue?vue&type=style&index=0&id=0d65b7a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65b7a0",
  null
  
)

export default component.exports